var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolidEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 3.375C16.3701 3.375 17 4.00459 17 4.78125C17 5.22363 16.792 5.63965 16.4375 5.90625L10.0625 10.6875C9.72852 10.9365 9.27148 10.9365 8.9375 10.6875L2.5625 5.90625C2.20839 5.63965 2 5.22363 2 4.78125C2 4.00459 2.62959 3.375 3.40625 3.375H15.5938ZM8.375 11.4375C9.04297 11.9385 9.95703 11.9385 10.625 11.4375L17 6.65625V12.75C17 13.7842 16.1592 14.625 15.125 14.625H3.875C2.83936 14.625 2 13.7842 2 12.75V6.65625L8.375 11.4375Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidEnvelope);
export default __webpack_public_path__ + "static/media/icon-solid-envelope.d3696f461904efe5a07a8f980fab0fda.svg";
export { ForwardRef as ReactComponent };